export const depDevices = {
    read(depAccountId, query) {
        return $.getJSON(AdminRoutes.adminDEPAccountDEPDevicesPath(depAccountId, query))
    },
};